/* eslint-disable */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Axios from "axios";
import cookie from "react-cookies";
import { appId, apiUrlV2, apiUrl, deliveryId } from "../../Helpers/Config";
import {
  getReferenceID,
  stripslashes,
  showPriceValue,
  showLoader,
  hideLoader,
  showCustomAlert,
  showAlert,
  removePromoCkValue,
} from "../../Helpers/SettingHelper";
import noimage from "../../../common/images/no-img-product.png";
var qs = require("qs");

import { GET_HIGHLIGHTPROLIST } from "../../../actions";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

var Parser = require("html-react-parser");

class Combomealproducts extends Component {
  constructor(props) {
    super(props);
    this.state = { pizzacount: "" };
  }

  componentWillMount() {
    this.props.getHighlightList();
  }

  proQtyAction(indxFlg, actionFlg) {
    var proqtyInput = $("#cmproIndex-" + indxFlg)
      .find(".proqty_input")
      .val();
    proqtyInput = parseInt(proqtyInput);
    if (actionFlg === "decr") {
      proqtyInput = proqtyInput > 1 ? proqtyInput - 1 : proqtyInput;
    } else {
      proqtyInput = proqtyInput + 1;
    }
    $("#cmproIndex-" + indxFlg)
      .find(".proqty_input")
      .val(proqtyInput);
  }

  componentDidMount() {
    Axios.get(apiUrl + "reports/pizzaCount?app_id=" + appId).then((res) => {
      /* Success response */
      if (res.data.status === "ok") {
        if (res.data.totalPizza > 0) {
          this.setState({ pizzacount: Parser(res.data.html) });
        }
      }
    });
  }

  /* add to cart */
  addToCartSimple(productDetail, actionFlg, event) {
    event.preventDefault();
    var avilablityId = cookie.load("defaultAvilablityId");
    var orderOutletId = cookie.load("orderOutletId");
    if (
      avilablityId !== "" &&
      orderOutletId != undefined &&
      orderOutletId !== "" &&
      orderOutletId != undefined
    ) {
      var IndexFlg = productDetail.product_primary_id;

      if (actionFlg === "initial") {
        $("#cmproIndex-" + IndexFlg).addClass("active");
        $("#cmproIndex-" + IndexFlg)
          .find(".smiple_product_lk")
          .hide();
        $("#cmproIndex-" + IndexFlg)
          .find(".addcart_done_maindiv")
          .show();
      } else {
        showLoader("cmproIndex-" + IndexFlg, "Idtext");
        var availabilityId = cookie.load("defaultAvilablityId");
        var availabilityName =
          availabilityId === deliveryId ? "Delivery" : "Pickup";
        var isAddonProduct = "No";
        var productId = productDetail.product_id;
        var customerId =
          typeof cookie.load("UserId") === "undefined"
            ? ""
            : cookie.load("UserId");
        var proqtyQty = $("#cmproIndex-" + IndexFlg)
          .find(".proqty_input")
          .val();

        var postObject = {};
        postObject = {
          app_id: appId,
          product_id: productId,
          product_qty: proqtyQty,
          product_type: 1,
          availability_id: availabilityId,
          availability_name: availabilityName,
          isAddonProduct: isAddonProduct,
          reference_id: customerId === "" ? getReferenceID() : "",
          customer_id: customerId,
        };

        Axios.post(
          apiUrlV2 + "cart/simpleCartInsert",
          qs.stringify(postObject)
        ).then((res) => {
          $("#cmproIndex-" + IndexFlg).removeClass("active");
          hideLoader("cmproIndex-" + IndexFlg, "Idtext");
          $("#cmproIndex-" + IndexFlg)
            .find(".addcart_done_maindiv")
            .hide();
          $("#cmproIndex-" + IndexFlg)
            .find(".smiple_product_lk")
            .show();
          if (res.data.status === "ok") {
            this.props.sateValChange("cartflg", "yes");
            /* showCustomAlert(
              "success",
              "Great choice! Item added to your cart."
            ); */
            removePromoCkValue();
            this.handleShowAlertFun(
              "success",
              "Great choice! Item added to your cart."
            );
            return false;
          } else if (res.data.status === "error") {
            var errMsgtxt =
              res.data.message !== ""
                ? res.data.message
                : "Sorry! Products can`t add your cart.";
            showCustomAlert("error", errMsgtxt);
          }
        });
      }
    } else {
      cookie.save("popuptriggerFrom", "FeaturedPro", { path: "/" });
      showAlert(
        "Error",
        "Please Select your Order Type - Delivery / Take-Away"
      );
      $.magnificPopup.open({
        items: {
          src: ".alert_popup",
        },
        type: "inline",
      });
      $(".avilablity-error").show();
      setTimeout(function () {
        $(".avilablity-error").hide();
      }, 3000);
    }
  }

  handleShowAlertFun(header, msg) {
    var magnfPopup = $.magnificPopup.instance;
    showAlert(header, msg, magnfPopup);
    $.magnificPopup.open({
      items: {
        src: ".alert_popup",
      },
      type: "inline",
    });
  }

  viewProDetail(productDetail, event) {
    event.preventDefault();
    var avilablityId = cookie.load("defaultAvilablityId");
    var orderOutletId = cookie.load("orderOutletId");
    if (
      avilablityId !== "" &&
      orderOutletId != undefined &&
      orderOutletId !== "" &&
      orderOutletId != undefined
    ) {
      var productSlug = productDetail.product_slug;
      if (productSlug !== "") {
        this.props.history.push(
          "/products/" +
            productDetail.pro_cate_slug +
            "/" +
            productDetail.pro_subcate_slug +
            "/" +
            productSlug
        );
        /* $("#cmproIndex-" + productDetail.product_primary_id).addClass("active");
        this.props.sateValChange("view_pro_data", productSlug); */
      }
    } else {
      cookie.save("popuptriggerFrom", "FeaturedPro", { path: "/" });
      $.magnificPopup.open({
        items: {
          src: "#order-popup",
        },
        type: "inline",
      });

      $(".avilablity-error").show();
      setTimeout(function () {
        $(".avilablity-error").hide();
      }, 3000);
    }
    return false;
  }
  padnewone(d) {
    var dd = parseInt(d);
    return dd < 10 ? "0" + dd.toString() : dd.toString();
  }

  render() {
    let highlightArr = this.props.highlightproduct;
    let highlightlist = [];
    let highlightimagesource = "";
    let tagimagesource = "";

    if (Object.keys(highlightArr).length > 0) {
      if (highlightArr[0].status === "ok") {
        highlightlist = highlightArr[0].result_set;
        highlightimagesource = highlightArr[0].common.image_source;
        tagimagesource = highlightArr[0].common.tag_image_source;
      }
    }
    var settingsGallery = {
      margin: 15,
      responsive: {
        0: {
          items: 2,
        },
        580: {
          items: 2,
        },
        780: {
          items: 3,
        },
        1100: {
          items: 4,
        },
      },
    };
    return (
      <section className="featuredpro-section">
        {Object.keys(highlightlist).length > 0 ? (
          <div className="featured-products-section">
            <div className="container">
              <div className="featured-products-header">
                {this.props.combomealsBlock !== "" &&
                  this.props.combomealsBlock}
              </div>
              <div className="featured-products-main">
                <OwlCarousel
                  className="products-list-ulmain"
                  {...settingsGallery}
                >
                  {highlightlist.map((highlight, index) => {
                    var prodivId = "cmproIndex-" + highlight.product_primary_id;
                    var comboProId = "cmcomboPro-" + highlight.product_slug;
                    return (
                      <div
                        className="products-single-li"
                        id={prodivId}
                        key={index}
                      >
                        <div className="products-image-div">
                          {highlight.product_thumbnail !== "" ? (
                            <img
                              src={
                                highlightimagesource +
                                "/" +
                                highlight.product_thumbnail
                              }
                            />
                          ) : (
                            <img src={noimage} />
                          )}
                        </div>

                        <div className="product-info-div">
                          <div className="product-title-maindiv">
                            <div className="product-title">
                              <h3>
                                {" "}
                                {highlight.product_alias !== ""
                                  ? stripslashes(highlight.product_alias)
                                  : stripslashes(highlight.product_name)}
                              </h3>
                            </div>
                          </div>
                          <div className="product-info-merge">
                            {highlight.product_tag !== null &&
                            Object.keys(highlight.product_tag).length > 0 ? (
                              <div className="product-tag-list">
                                <ul>
                                  {highlight.product_tag.map(
                                    (producttag, index1) => {
                                      return (
                                        <li key={index1}>
                                          {producttag.pro_tag_image !== "" ? (
                                            <img
                                              src={
                                                tagimagesource +
                                                producttag.pro_tag_image
                                              }
                                            />
                                          ) : (
                                            ""
                                          )}
                                        </li>
                                      );
                                    }
                                  )}
                                </ul>
                              </div>
                            ) : (
                              ""
                            )}
                            <div className="product-short-description">
                              <p>
                                {highlight.product_short_description != ""
                                  ? Parser(
                                      stripslashes(
                                        highlight.product_short_description
                                      )
                                    )
                                  : Parser("&nbsp;")}
                              </p>
                            </div>

                            <div className="product-price">
                              <h3>{showPriceValue(highlight.product_price)}</h3>
                            </div>

                            <div className="products-ordernow-action">
                              <div className="addcart_row addcart_done_maindiv">
                                <div className="qty_bx">
                                  <span
                                    className="qty_minus"
                                    onClick={this.proQtyAction.bind(
                                      this,
                                      highlight.product_primary_id,
                                      "decr"
                                    )}
                                  >
                                    -
                                  </span>
                                  <input
                                    type="text"
                                    className="proqty_input"
                                    readOnly
                                    value="1"
                                  />
                                  <span
                                    className="qty_plus"
                                    onClick={this.proQtyAction.bind(
                                      this,
                                      highlight.product_primary_id,
                                      "incr"
                                    )}
                                  >
                                    +
                                  </span>
                                </div>
                                <button
                                  className="btn btn_black order_done"
                                  onClick={this.addToCartSimple.bind(
                                    this,
                                    highlight,
                                    "done"
                                  )}
                                >
                                  Done
                                </button>
                              </div>

                              {highlight.product_stock > 0 ||
                              highlight.product_stock === null ? (
                                highlight.product_type === "1" ? (
                                  <a
                                    className="button order_nowdiv smiple_product_lk disbl_href_action"
                                    href="/"
                                    onClick={this.addToCartSimple.bind(
                                      this,
                                      highlight,
                                      "initial"
                                    )}
                                  >
                                    Select
                                  </a>
                                ) : (
                                  <a
                                    href="/"
                                    onClick={this.viewProDetail.bind(
                                      this,
                                      highlight
                                    )}
                                    title="Product Details"
                                    id={comboProId}
                                    className="button order_nowdiv compo_product_lk"
                                  >
                                    Select
                                  </a>
                                )
                              ) : (
                                <a
                                  className="button disabled disbl_href_action"
                                  href="/"
                                >
                                  Sold Out
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </OwlCarousel>
              </div>
              <Link to={"/products"} className="button load-more-weight">
                Load More
              </Link>
              {this.state.pizzacount !== "" && (
                <div className="dod-content pizza-counter">
                  <h2>Pizza Count</h2>
                  <div id="pizza_count">{this.state.pizzacount}</div>
                </div>
              )}
            </div>
          </div>
        ) : (
          ""
        )}
      </section>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    highlightproduct: state.highlightproductlist,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getHighlightList: () => {
      dispatch({ type: GET_HIGHLIGHTPROLIST });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Combomealproducts);
